export class Fee {
	private fiat_id: string = "";
	private fee_fix: string = "";
	private fee_max: string = "";
	private fee_percent: string = "";
	private allowed_payout_accounts = 0;
	private savings_enabled: boolean = false;
	private vip_fee_percent_difference: string = "";
	private information_available: boolean = false;

	public getFiatId(): string {
		return this.fiat_id;
	}

	public getFeeFix(): number {
		return +this.fee_fix;
	}

	public getFeeMax(): number {
		return +this.fee_max;
	}

	public getFeePercent(): number {
		return +this.fee_percent;
	}

	public getAllowedPayoutAccounts(): number {
		return this.allowed_payout_accounts;
	}

	public isSavingsEnabled(): boolean {
		return this.savings_enabled;
	}

	public getFeeDifference(): number {
		return +this.vip_fee_percent_difference;
	}

	public getInfoAvailable(): boolean {
		return this.information_available;
	}

	public get free(): boolean {
		return this.getFeeFix() === 0 && this.getFeePercent() === 0;
	}
}
